import React from 'react';
const ToppersModal = ({ toppers, onClose, examTitle }) => (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full text-center relative overflow-hidden animate-fade-in-up">
            {/* Confetti-like background decoration (optional CSS) */}
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-yellow-300 via-yellow-500 to-yellow-300"></div>
            
            <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-orange-500 mb-2">
                🎉 Hall of Fame 🎉
            </h2>
            <p className="text-gray-500 mb-6 font-medium">Top Performers for {examTitle}</p>

            <div className="space-y-4">
                {toppers && toppers.length > 0 ? toppers.map((student, index) => {
                    let styleClass = "bg-white border-gray-200";
                    let icon = "🏅";
                    let rankLabel = `#${index + 1}`;
                    let textClass = "text-gray-700";

                    if (index === 0) { 
                        styleClass = "bg-yellow-50 border-yellow-400 shadow-lg scale-105 z-10"; 
                        icon = "🥇"; 
                        textClass = "text-yellow-800";
                        rankLabel = "1st";
                    } else if (index === 1) { 
                        styleClass = "bg-gray-50 border-gray-300"; 
                        icon = "🥈"; 
                        rankLabel = "2nd";
                    } else if (index === 2) { 
                        styleClass = "bg-orange-50 border-orange-200"; 
                        icon = "🥉"; 
                        rankLabel = "3rd";
                    }

                    return (
                        <div key={index} className={`flex items-center p-4 rounded-lg border-2 ${styleClass} transition-transform`}>
                            <div className="text-4xl mr-4 filter drop-shadow-sm">{icon}</div>
                            <div className="text-left flex-grow">
                                <p className={`font-bold text-lg ${textClass}`}>{student.name}</p>
                                <p className="text-xs text-gray-500 font-mono">Score: {student.score}</p>
                            </div>
                            <div className="font-black text-xl text-gray-300 italic">
                                {rankLabel}
                            </div>
                        </div>
                    );
                }) : (
                    <p className="text-gray-500">No toppers declared yet.</p>
                )}
            </div>

            <button
                onClick={onClose}
                className="mt-8 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-2 rounded-full hover:from-purple-700 hover:to-pink-700 transition shadow-lg font-bold"
            >
                Close
            </button>
        </div>
    </div>
);
export default ToppersModal;